<template>
  <v-card
    v-if="showOutboundTicket"
  >
    <v-card-title>
      <v-row>
        <v-col
          cols="3"
          md="3"
          sm="3"
        >
          Ticket Campaign
        </v-col>
        <v-spacer />
        <v-col
          cols="4"
          md="4"
          sm="4"
        >
          <p class="mb-0">
            Campaign Name: {{ currentOutboundTicket?.campaign?.name ?? '' }}
          </p>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-row
        class="my-1"
      >
        <v-col
          cols="5"
          md="5"
          sm="5"
        >
          <v-card
            loading="false"
            elevation="2"
            outlined
            tile
          >
            <v-card-title
              class=""
            >
              <h2>Instructions</h2>
            </v-card-title>
            <v-divider class="mx-4" />
            <v-card-text>
              <p class="mb-0">
                {{ currentOutboundTicket.campaign?.instructions ?? '' }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-divider vertical />
        <v-col>
          <v-card>
            <v-card-title>
              <h2>Customer Data</h2>
            </v-card-title>
            <v-divider class="mx-4" />
            <v-card-text>
              <pre class="mb-0">
              <JsonFormatterWrapper
                :data="currentOutboundTicket.customer?.data ?? []"
              />
            </pre>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-divider />
      <v-row
        class="mt-1"
      >
        <v-col
          cols="5"
          sm="5"
          md="5"
        >
          <v-card
            class="outbound-show-actions"
            elevation="2"
            loading="false"
            outlined
            tile
          >
            <v-card-title class="pb-0">
              <v-text-field
                v-model="searchAction"
                class="search"
                outlined
                label="Search for an action to carry out"
                prepend-inner-icon="mdi-magnify"
              />
            </v-card-title>
            <v-card-text class="py-0">
              <v-list flat>
                <v-subheader>OUTBOUND ACTIONS</v-subheader>
                <v-list-item-group
                  color="primary"
                >
                  <v-list-item
                    v-for="(item, i) in filteredActions"
                    :key="i"
                    @click="redirectComponent(item.name)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon" />
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <v-divider vertical />
        <v-col>
          <div v-if="!currentComponent">
            <v-alert
              color="primary"
              dark
              icon="mdi-bell-alert"
              border="left"
              prominent
            >
              <h3>No PDS option Selected!</h3>
              <p>Please select an option in the left menu</p>
            </v-alert>
          </div>
          <component
            :is="currentComponent"
            v-else-if="currentComponent && customer"
            :ticket="ticket"
            :autopays="autopays"
            :payments="payments"
            :payment-schedules="paymentSchedules"
            :customer="customer"
            :payment-profiles="paymentProfiles"
            :is-call-campaign="true"
            @resetComponent="handleResetComponent"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import JsonFormatterWrapper from '@/views/Leads/JsonFormatterWrapper.vue';
import TicketCommunicationMacros from '@/views/Tickets/Communications/Index.vue';
import TicketPDSPayment from '@/views/Tickets/TicketPDSPayment.vue';

export default {
  name: 'TicketOutboundCampaign',
  components: {
    JsonFormatterWrapper,
    TicketCommunicationMacros,
    TicketPDSPayment,
  },

  data() {
    return {
      currentOutboundTicket: null,
      searchAction: '',
    };
  },

  computed: {
    ...mapState('ticket', ['outboundTicket']),
    ...mapState('outboundActions', ['actions']),
    ...mapGetters('outboundActions', ['getActiveComponent']),
    ...mapState('ticket', ['ticket', 'allowAccess']),
    ...mapState('loanProCustomer', ['customer', 'paymentProfiles']),
    ...mapState('loanProLoan', ['autopays', 'payments', 'paymentSchedules']),
    showOutboundTicket() {
      return this.currentOutboundTicket;
    },

    currentComponent() {
      return this.getActiveComponent?.component?.name ?? '';
    },

    filteredActions() {
      if (this.searchAction) {
        return this.actions.filter((item) => this.searchAction.toLowerCase().split(' ').every((v) => item.text.toLowerCase().includes(v)));
      }

      return this.actions;
    },
  },

  async mounted() {
    await this.getTbotActions(this.$route.params.id);
    this.backendCheck();
  },

  methods: {
    ...mapActions('ticket', ['setOutboundTicket']),
    ...mapActions('outboundActions', ['getTbotActions', 'setActiveAction', 'resetActiveActions']),
    handleResetComponent() {
      this.resetActiveActions();
    },

    redirectComponent(component) {
      this.setActiveAction(component);
    },

    backendCheck() {
      this.$axios.post('api/v1/support/outbound-call-campaign/campaign-customer', {
        ticketId: this.$route.params.id,
      })
        .then((res) => {
          if (res.data?.data) {
            this.currentOutboundTicket = res.data?.data;
            this.setOutboundTicket(this.currentOutboundTicket);
          } else {
            this.setOutboundTicket({ campaign: null, customer: null });
          }
        })
        .catch((error) => {
          this.processingNextCustomer = false;
          this.items = [];
          let errMsg = 'There was an error processing your request';
          if (error.response && error.response.status === 404 && error.response.data) {
            errMsg = error.response.data.message;
          }

          if (error.response && error.response.status === 422) {
            errMsg = error.response.data.message;
            if (error.response.data.errors) {
              Object.values(error.response.data.errors).forEach((val) => {
                errMsg += `\n ${val}`;
              });
            }
          }

          if (error.response && error.response.status === 500) {
            errMsg = error.response.data.message;
          }

          this.loadingModel = false;
          this.setNotification({
            message: errMsg,
            color: 'red',
          });
        });
    },
  },
};
</script>

<style scoped>

</style>
